import React, { forwardRef } from 'react';

export const INPUT_BASE =
  'w-full min-w-0 min-h-[44px] px-3.5 py-2.5 text-sm bg-surface text-content placeholder:text-content-muted ' +
  'border rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent ' +
  'disabled:opacity-50 disabled:bg-surface-2';

const Input = forwardRef(function Input(
  { invalid = false, warning = false, startAdornment, endAdornment, className = '', ...rest },
  ref
) {
  // `warning` mirrors SearchableSelect's amber "OCR couldn't match this
  // field" border so a free-text fallback input (VehicleModal's Model field)
  // can carry the same highlight a catalog-backed picker would have shown.
  const borderClass = invalid
    ? 'border-red-500 dark:border-red-400'
    : warning
      ? 'border-amber-400 dark:border-amber-500/60'
      : 'border-edge-strong';
  if (!startAdornment && !endAdornment) {
    return <input ref={ref} className={`${INPUT_BASE} ${borderClass} ${className}`} {...rest} />;
  }
  // The wrapper inherits the page direction, but the input may set its own
  // (an IBAN or a phone number is LTR on an Arabic page). Without mirroring it
  // here, `start-0` on the adornment resolves to the RTL side while the input's
  // `ps-10` padding resolves to the LTR one — badge on the right, digits
  // starting on the left, with a gap between them.
  return (
    <div className="relative" dir={rest.dir}>
      {startAdornment && (
        <span className="absolute inset-y-0 start-0 flex items-center ps-3.5 text-content-muted pointer-events-none">
          {startAdornment}
        </span>
      )}
      <input
        ref={ref}
        className={`${INPUT_BASE} ${borderClass} ${startAdornment ? 'ps-10' : ''} ${endAdornment ? 'pe-10' : ''} ${className}`}
        {...rest}
      />
      {endAdornment && (
        <span className="absolute inset-y-0 end-0 flex items-center pe-3.5 text-content-muted">{endAdornment}</span>
      )}
    </div>
  );
});

export default Input;
